import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
    selector: '[blackTabsContent]',
    standalone: false
})
export class TabsContentDirective {  templateRef = inject<TemplateRef<any>>(TemplateRef);

}
